import { Selector } from '@ngxs/store';

import { BcStateContext, BcStateListContext } from '@bayclubs/state';
import { BcCalendarEvent, BcCalendarResource, BcCalendarSettings } from '@bayclubs/calendar';

import { ClassesCalendarStateModel } from './classes-calendar.state.model';
import { ClassesCalendarState } from './classes-calendar.state';

export class ClassesCalendarSelectors {
    @Selector([ClassesCalendarState])
    static calendarEvents(state: ClassesCalendarStateModel): BcStateListContext<BcCalendarEvent> {
        return state.calendarEvents;
    }
    @Selector([ClassesCalendarState])
    static calendarResources(state: ClassesCalendarStateModel): BcStateListContext<BcCalendarResource> {
        return state.calendarResources;
    }
    @Selector([ClassesCalendarState])
    static calendarSettings(state: ClassesCalendarStateModel): BcStateContext<BcCalendarSettings> {
        return state.calendarSettings;
    }

    @Selector([ClassesCalendarState])
    static selectedClubId(state: ClassesCalendarStateModel): string {
        return state.selectedClubId;
    }

    @Selector([ClassesCalendarState])
    static eventIds(state: ClassesCalendarStateModel): string[] {
        return state.calendarEvents.hasItems ? state.calendarEvents.items.map(ce => ce.id) : [];
    }
}
